import * as React from 'react';
export const IcAceOfSpades = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M13.84 3l-.49-.45a2 2 0 00-2.7 0l-.49.45C5.63 7.14 3 10.2 3 13.56A5.36 5.36 0 008.4 19a5.16 5.16 0 002.28-.59l-1.07 2.14A1 1 0 0010.5 22h3a1 1 0 00.89-1.45l-1.07-2.14a5.16 5.16 0 002.28.59 5.36 5.36 0 005.4-5.44c0-3.37-2.63-6.43-7.16-10.56z'
      fill='currentColor'
    />
  </svg>
);
